// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DateFns = require("date-fns");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let WizardFormValidation = require("../wizard/WizardFormValidation.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyType_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyType_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeHalfBaths_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeHalfBaths_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLivingArea_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLivingArea_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.bs.js");
let PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let DraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let DraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let DraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let DraftFragment = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString,
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  rentalPropertyTypeEnumV5_decode: DraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: DraftFragment_rentalPropertyTypeEnumV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function useIsValid(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypePropertyType_draft_graphql.node, convertFragment, draft);
  let match = draft$1.draftProperty;
  if (match.propertyType === "FOR_SALE") {
    if (match.forSalePropertyType !== undefined) {
      return "Valid";
    } else {
      return {
        NAME: "Error",
        VAL: "is required"
      };
    }
  } else if (match.rentalPropertyType !== undefined) {
    return "Valid";
  } else {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

let PropertyType = {
  DraftFragment: DraftFragment,
  useIsValid: useIsValid
};

let convertFragment$1 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment_forSalePropertyTypeEnumV5_decode$1 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let DraftFragment_forSalePropertyTypeEnumV5_fromString$1 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let DraftFragment_localDraftPropertyType_decode$1 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString$1 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment$1 = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode$1,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString$1,
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode$1,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useIsValid$1(draft) {
  let match = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLotSize_draft_graphql.node, convertFragment$1, draft);
  let match$1 = match.draftProperty;
  let forSalePropertyType = match$1.forSalePropertyType;
  if (match$1.lotSize !== undefined) {
    return "Valid";
  } else if (match$1.propertyType === "FOR_SALE" && forSalePropertyType === "LOT") {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  } else {
    return;
  }
}

let LotSize = {
  DraftFragment: DraftFragment$1,
  useIsValid: useIsValid$1
};

let convertFragment$2 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLivingArea_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLivingArea_draft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLivingArea_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLivingArea_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLivingArea_draft_graphql.node, convertFragment$2, fRef);
}

let DraftFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function useIsValid$2(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLivingArea_draft_graphql.node, convertFragment$2, draft);
  let match = draft$1.draftProperty;
  if (match.livingArea !== undefined) {
    return "Valid";
  }
}

let LivingArea = {
  DraftFragment: DraftFragment$2,
  useIsValid: useIsValid$2
};

let convertFragment$3 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeHalfBaths_draft_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeHalfBaths_draft_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeHalfBaths_draft_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeHalfBaths_draft_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeHalfBaths_draft_graphql.node, convertFragment$3, fRef);
}

let DraftFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function useIsValid$3(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeHalfBaths_draft_graphql.node, convertFragment$3, draft);
  let match = draft$1.draftProperty;
  if (match.halfBaths !== undefined) {
    return "Valid";
  }
}

let HalfBaths = {
  DraftFragment: DraftFragment$3,
  useIsValid: useIsValid$3
};

let convertFragment$4 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.node, convertFragment$4, fRef);
}

let DraftFragment_forSalePropertyTypeEnumV5_decode$2 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let DraftFragment_forSalePropertyTypeEnumV5_fromString$2 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let DraftFragment_rentalPropertyTypeEnumV5_decode$1 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let DraftFragment_rentalPropertyTypeEnumV5_fromString$1 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let DraftFragment$4 = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode$2,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString$2,
  rentalPropertyTypeEnumV5_decode: DraftFragment_rentalPropertyTypeEnumV5_decode$1,
  rentalPropertyTypeEnumV5_fromString: DraftFragment_rentalPropertyTypeEnumV5_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function useIsValid$4(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBaths_draft_graphql.node, convertFragment$4, draft);
  let match = draft$1.draftProperty;
  if (match.baths !== undefined) {
    let match$1 = match.forSalePropertyType;
    if (match$1 !== undefined && (match$1 === "CONDO" || match$1 === "SINGLE_FAMILY" || match$1 === "LOT" || match$1 === "MULTI_UNIT")) {
      switch (match$1) {
        case "CONDO" :
        case "SINGLE_FAMILY" :
          return "Valid";
      }
    }
    let match$2 = match.rentalPropertyType;
    if (match$2 !== undefined && (match$2 === "CONDO" || match$2 === "SINGLE_FAMILY")) {
      return "Valid";
    } else {
      return;
    }
  }
  let match$3 = match.forSalePropertyType;
  if (match$3 !== undefined && (match$3 === "CONDO" || match$3 === "SINGLE_FAMILY" || match$3 === "LOT" || match$3 === "MULTI_UNIT")) {
    switch (match$3) {
      case "CONDO" :
      case "SINGLE_FAMILY" :
        return {
          NAME: "Error",
          VAL: "is required"
        };
    }
  }
  let match$4 = match.rentalPropertyType;
  if (match$4 !== undefined && (match$4 === "CONDO" || match$4 === "SINGLE_FAMILY")) {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

let Baths = {
  DraftFragment: DraftFragment$4,
  useIsValid: useIsValid$4
};

let convertFragment$5 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.node, convertFragment$5, fRef);
}

let DraftFragment_forSalePropertyTypeEnumV5_decode$3 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let DraftFragment_forSalePropertyTypeEnumV5_fromString$3 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let DraftFragment_rentalPropertyTypeEnumV5_decode$2 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

let DraftFragment_rentalPropertyTypeEnumV5_fromString$2 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

let DraftFragment$5 = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode$3,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString$3,
  rentalPropertyTypeEnumV5_decode: DraftFragment_rentalPropertyTypeEnumV5_decode$2,
  rentalPropertyTypeEnumV5_fromString: DraftFragment_rentalPropertyTypeEnumV5_fromString$2,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function useIsValid$5(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeBeds_draft_graphql.node, convertFragment$5, draft);
  let match = draft$1.draftProperty;
  if (match.beds !== undefined) {
    let match$1 = match.forSalePropertyType;
    if (match$1 !== undefined && (match$1 === "CONDO" || match$1 === "SINGLE_FAMILY" || match$1 === "LOT" || match$1 === "MULTI_UNIT")) {
      switch (match$1) {
        case "CONDO" :
        case "SINGLE_FAMILY" :
          return "Valid";
      }
    }
    let match$2 = match.rentalPropertyType;
    if (match$2 !== undefined && (match$2 === "CONDO" || match$2 === "SINGLE_FAMILY")) {
      return "Valid";
    } else {
      return;
    }
  }
  let match$3 = match.forSalePropertyType;
  if (match$3 !== undefined && (match$3 === "CONDO" || match$3 === "SINGLE_FAMILY" || match$3 === "LOT" || match$3 === "MULTI_UNIT")) {
    switch (match$3) {
      case "CONDO" :
      case "SINGLE_FAMILY" :
        return {
          NAME: "Error",
          VAL: "is required"
        };
    }
  }
  let match$4 = match.rentalPropertyType;
  if (match$4 !== undefined && (match$4 === "CONDO" || match$4 === "SINGLE_FAMILY")) {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

let Beds = {
  DraftFragment: DraftFragment$5,
  useIsValid: useIsValid$5
};

let convertFragment$6 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql.Internal.convertFragment;

function waitForFragmentData$6(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql.node, convertFragment$6, fRef);
}

function use$6(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql.node, convertFragment$6, fRef);
}

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql.node, convertFragment$6);
}

function readResolverFragment$6(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql.node, convertFragment$6, fRef);
}

let DraftFragment_forSalePropertyTypeEnumV5_decode$4 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let DraftFragment_forSalePropertyTypeEnumV5_fromString$4 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let DraftFragment$6 = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode$4,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString$4,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$6,
  waitForFragmentData: waitForFragmentData$6,
  use: use$6,
  useOpt: useOpt$6,
  readResolverFragment: readResolverFragment$6
};

function useIsValid$6(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeNumberOfUnits_draft_graphql.node, convertFragment$6, draft);
  let match = draft$1.draftProperty;
  let match$1 = match.forSalePropertyType;
  if (match$1 === "MULTI_UNIT") {
    if (match.numberOfUnits !== undefined) {
      return "Valid";
    } else {
      return {
        NAME: "Error",
        VAL: "is required"
      };
    }
  }
}

let NumberOfUnits = {
  DraftFragment: DraftFragment$6,
  useIsValid: useIsValid$6
};

let convertFragment$7 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.Internal.convertFragment;

function waitForFragmentData$7(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.node, convertFragment$7, fRef);
}

function use$7(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.node, convertFragment$7, fRef);
}

function useOpt$7(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.node, convertFragment$7);
}

function readResolverFragment$7(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.node, convertFragment$7, fRef);
}

let DraftFragment_leaseLengthValue_decode = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.Utils.leaseLengthValue_decode;

let DraftFragment_leaseLengthValue_fromString = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.Utils.leaseLengthValue_fromString;

let DraftFragment_localDraftPropertyType_decode$2 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString$2 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment$7 = {
  leaseLengthValue_decode: DraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: DraftFragment_leaseLengthValue_fromString,
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode$2,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString$2,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$7,
  waitForFragmentData: waitForFragmentData$7,
  use: use$7,
  useOpt: useOpt$7,
  readResolverFragment: readResolverFragment$7
};

function useIsValid$7(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeLengthOfLease_draft_graphql.node, convertFragment$7, draft);
  let match = draft$1.draftProperty;
  if (match.leaseLength !== undefined) {
    if (match.propertyType === "FOR_SALE") {
      return;
    } else {
      return "Valid";
    }
  } else if (match.propertyType === "FOR_SALE") {
    return;
  } else {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

let LeaseLength = {
  DraftFragment: DraftFragment$7,
  useIsValid: useIsValid$7
};

let convertFragment$8 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql.Internal.convertFragment;

function waitForFragmentData$8(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql.node, convertFragment$8, fRef);
}

function use$8(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql.node, convertFragment$8, fRef);
}

function useOpt$8(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql.node, convertFragment$8);
}

function readResolverFragment$8(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql.node, convertFragment$8, fRef);
}

let DraftFragment_localDraftPropertyType_decode$3 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString$3 = PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment$8 = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode$3,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString$3,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$8,
  waitForFragmentData: waitForFragmentData$8,
  use: use$8,
  useOpt: useOpt$8,
  readResolverFragment: readResolverFragment$8
};

function useIsValid$8(draft) {
  let match = PropertyWizardFormRelay.Context.use();
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyTypeAvailableFrom_draft_graphql.node, convertFragment$8, draft);
  let today = CalendarDate.toLocalDate(CalendarDate.today(DateFnsTz.Timezone.make(draft$1.timeZone)));
  let match$1 = draft$1.draftProperty;
  let availableFrom = match$1.availableFrom;
  if (availableFrom !== undefined) {
    if (match$1.propertyType === "FOR_SALE") {
      return;
    } else if (match.mode === "New" && DateFns.isAfter(today, CalendarDate.toLocalDate(Primitive_option.valFromOption(availableFrom)))) {
      return {
        NAME: "Error",
        VAL: "must be after today"
      };
    } else {
      return "Valid";
    }
  } else if (match$1.propertyType === "FOR_SALE") {
    return;
  } else {
    return {
      NAME: "Error",
      VAL: "is required"
    };
  }
}

let AvailableFrom = {
  DraftFragment: DraftFragment$8,
  useIsValid: useIsValid$8
};

let convertFragment$9 = PropertyWizardFormRelayValidatorsKeyFactsPropertyType_draft_graphql.Internal.convertFragment;

function waitForFragmentData$9(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsPropertyType_draft_graphql.node, convertFragment$9, fRef);
}

function use$9(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyType_draft_graphql.node, convertFragment$9, fRef);
}

function useOpt$9(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsPropertyType_draft_graphql.node, convertFragment$9);
}

function readResolverFragment$9(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsPropertyType_draft_graphql.node, convertFragment$9, fRef);
}

let DraftFragment$9 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$9,
  waitForFragmentData: waitForFragmentData$9,
  use: use$9,
  useOpt: useOpt$9,
  readResolverFragment: readResolverFragment$9
};

function useIsValid$9(draft) {
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsPropertyType_draft_graphql.node, convertFragment$9, draft);
  return WizardFormValidation.allValid([
    useIsValid$8(draft$1.fragmentRefs),
    useIsValid$7(draft$1.fragmentRefs),
    useIsValid$6(draft$1.fragmentRefs),
    useIsValid$5(draft$1.fragmentRefs),
    useIsValid$4(draft$1.fragmentRefs),
    useIsValid$3(draft$1.fragmentRefs),
    useIsValid$2(draft$1.fragmentRefs),
    useIsValid$1(draft$1.fragmentRefs),
    useIsValid(draft$1.fragmentRefs)
  ]);
}

exports.PropertyType = PropertyType;
exports.LotSize = LotSize;
exports.LivingArea = LivingArea;
exports.HalfBaths = HalfBaths;
exports.Baths = Baths;
exports.Beds = Beds;
exports.NumberOfUnits = NumberOfUnits;
exports.LeaseLength = LeaseLength;
exports.AvailableFrom = AvailableFrom;
exports.DraftFragment = DraftFragment$9;
exports.useIsValid = useIsValid$9;
/* date-fns Not a pure module */
